const QuickBuyIcon = ({ width }) => {
    return (
        <div className={`quick-buy-icon ${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enableBackground="new 0 0 300 300"
                version="1.1"
                viewBox="0 0 300 300"
                xmlSpace="preserve"
            >
                <path
                    fill="#6B665F"
                    d="M193.1 70.3V45.8c0-23.8-19.4-43.1-43.1-43.1-23.8 0-43.1 19.4-43.1 43.1v24.4H36.5v227h227v-227h-70.4zm-69.9-24.5c0-14.8 12-26.8 26.8-26.8s26.8 12 26.8 26.8v24.4h-53.6V45.8zm124 235.2H52.8V86.6h54.1v15.7h16.3V86.6h53.6v15.7h16.3V86.6h54.1V281z"
                    className="st0"
                ></path>
                <path
                    fill="#6B665F"
                    d="M153.5 133.8L146.5 133.8 146.5 180.3 100 180.3 100 187.3 146.5 187.3 146.5 233.8 153.5 233.8 153.5 187.3 200 187.3 200 180.3 153.5 180.3z"
                    className="st0"
                ></path>
            </svg>
        </div>
    )
}

export default QuickBuyIcon
